import type { FieldElement } from './types';

// Each mounted card subscribes to query/mutation state. Keep the mounted set
// bounded even when a site contains thousands of elements imported from RD.
export const ELEMENT_PAGE_SIZE = 25;

type SearchableElement = Pick<
  FieldElement,
  'code' | 'title' | 'section' | 'titul' | 'axes' | 'marks'
>;

export function filterElementRegistry<T extends SearchableElement>(
  elements: readonly T[],
  query: string,
): readonly T[] {
  const terms = query.trim().toLocaleLowerCase('ru').split(/\s+/).filter(Boolean);
  if (terms.length === 0) return elements;
  return elements.filter((element) => {
    const text = [
      element.code,
      element.title,
      element.section,
      element.titul,
      element.axes,
      element.marks,
    ]
      .filter(Boolean)
      .join(' ')
      .toLocaleLowerCase('ru');
    return terms.every((term) => text.includes(term));
  });
}

export function elementRegistryPage<T>(elements: readonly T[], requestedPage: number) {
  const pages = Math.max(1, Math.ceil(elements.length / ELEMENT_PAGE_SIZE));
  const page = Math.min(
    pages,
    Math.max(1, Number.isFinite(requestedPage) ? Math.floor(requestedPage) : 1),
  );
  const offset = (page - 1) * ELEMENT_PAGE_SIZE;
  return {
    page,
    pages,
    start: elements.length ? offset + 1 : 0,
    end: Math.min(offset + ELEMENT_PAGE_SIZE, elements.length),
    items: elements.slice(offset, offset + ELEMENT_PAGE_SIZE),
  };
}
